export const UTCRemove = (time) => time.substring(0, time.length - 5);
